/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { ViewModel } from "../viewmodel/viewmodel"

import type { ErrorLog, LoggerStore, OkLog } from "./logger-store"

export class LoggerViewModel implements ViewModel {
    name: string = this.constructor.name

    constructor(private readonly store: LoggerStore) {}

    get errors(): ErrorLog[] {
        return this.store.errors
    }

    get lastError(): ErrorLog | null {
        return this.store.lastError
    }

    get lastOkLog(): OkLog | null {
        return this.store.lastOkLog
    }

    // log
    logError(error: Error): void {
        this.store.logError(error)
    }

    logErrorMessage(message: string): void {
        this.store.logError({
            message,
            appError: new Error(message)
        })
    }

    logOk(message: string): void {
        this.store.logOk(message)
    }

    // clear
    clearLastError(): void {
        this.store.clearLastError()
    }

    clearLastOkLog(): void {
        this.store.clearLastOkLog()
    }

    clearErrors(): void {
        this.store.clearErrors()
    }
}
